<template>
  <v-card class="ma-1">
    <!-- {{quoting}} -->
    <v-container grid-list-xs>
      <v-layout row wrap>
        <v-flex hidden-xs-only xs12 sm12 md12 lg12 xl12 class="text-xs-center text-sm-right text-md-right text-lg-right text-xl-right">
          <v-layout text-lg-right>
            <v-spacer></v-spacer>
            <div class="text-lg-right">
              <v-img :src="quoting.icon" height="50" width="70"></v-img>
            </div>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12 xl12 class="text-xs-center text-sm-left text-md-left text-lg-left text-xl-left">
          <h3 class="title" style="color:#005cae">
            <strong>{{quoting.name}}</strong>
          </h3>
          <p class="caption text--secondary" style="font-size:13.5px!important">
            {{quoting.description}}
          </p>
        </v-flex>
        <v-flex xs4 hidden-sm-and-up></v-flex>
        <v-flex hidden-sm-and-up xs8 sm2 md2 lg2 xl2 class="text-xs-center">
          <div>
            <v-img :src="quoting.icon" width="120"></v-img>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        class="hidden-sm-and-up"
        style="margin:0px"
        small
        color="accent"
        dark
        :href="quoting.url"
        target="_blank"
      >{{$t('message.open')}}</v-btn>
    </v-card-actions>
    <v-footer class="hidden-xs-only" absolute style="bottom:3.5%">
      <v-spacer></v-spacer>
      <v-card-actions>
        <v-btn
          style="margin:0px"
          small
          color="accent"
          dark
          :href="quoting.url"
          target="_blank"
        >{{$t('message.open')}}</v-btn>
      </v-card-actions>
    </v-footer>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";
import Vue from "vue";
export default {
  mounted() {},
  /*   cssProps() {
    return {
      "--accent-color": this.$vuetify.theme.accent
    };
  }, */
  props: {
    quoting: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>
<style scoped>
.text--accent {
  color: var(--accent-color);
}
</style>